import React from 'react';
import { AuxTypeCode, LightConfig, LightTypeMode } from '@/types/device';
import { FiClock } from 'react-icons/fi';
import { SchedulePanel } from "@/components/ui/DeviceCard/schedulePanel";
import { formatMinutesToTime } from '@/utils/time';
import { AuxWithSchedules, PoolLightSwitchMode, ScheduleInfo } from '@/types/dashboard';
import { getWeekdayArray, SPA_ELECTRICS_COLORS, AQUAQUIP_COLORS, PAL_COLORS } from '@/utils/utils';
import { getNextActionTextBySlot } from '@/utils/schedule';
import { formatAuxTimerCountdown, formatAuxTimerDuration } from '@/utils/auxTimer';
import Switch from '@mui/material/Switch';


interface OtherDevicesSectionProps {
  devicesList: AuxWithSchedules[];
  scheduleInfo?: ScheduleInfo;
  onDeviceToggle: (typeCode: number, slotNum: number, IsOn: boolean) => void;
  poolLightSwitchMode?: PoolLightSwitchMode;
  onLightColorClick?: (device: AuxWithSchedules, lightConfig: any) => void;
}


const OtherDevicesSection: React.FC<OtherDevicesSectionProps> = ({
  devicesList,
  scheduleInfo,
  onDeviceToggle,
  poolLightSwitchMode,
  onLightColorClick
}) => {
  //遍历devicesList，找到aux_type_code为ASTRAL_POOL_LIGHT、POOLRITE_LIGHT、AQUAQUIP_LIGHT、SPA_ELECTRICS_LIGHT的设备，
  //并将其lightColor和lightColourCode赋值为aux.aux_light_color和aux.aux_light_colour_code
  /*
  poolLightType：g_pool_light_type : 这个是aux的code
  poolLightTypeMode：g_pool_light_type_mode：这个是灯的类型
  poolLightColourType：g_pool_light_mode：这个是颜色的类型

  this.setLightAdapter(
                poolLightType,
                poolLightTypeMode,
                poolLightColourType,
                spaLightType,
                spaLightTypeMode,
                spaLightColourType
            )

  private fun setLightAdapter(
        poolLightType: AuxTypeCode,
        poolLightTypeMode: LightTypeMode,
        poolLightColourType: LightColourType,
        spaLightType: AuxTypeCode,
        spaLightTypeMode: LightTypeMode,
        spaLightColourType: LightColourType,
    )

  
  */
  devicesList.forEach(device => {
    const isPoolLight = device.aux.aux_type_code === poolLightSwitchMode?.g_pool_light_type;
    const isSpaLight = device.aux.aux_type_code === poolLightSwitchMode?.g_spa_light_type;
    
    if (isPoolLight && poolLightSwitchMode) {
      // Handle pool light
      if (device.aux.aux_type_code === AuxTypeCode.AQUAQUIP_LIGHT) {
        // AquaQuip Pool Light
        if (poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.AQUAQUIP_INSTA_TOUCH) {
          // AquaQuip Insta Touch Brand with color palette
          const colorMode = AQUAQUIP_COLORS.find(c => c.value === poolLightSwitchMode.g_pool_light_mode) || AQUAQUIP_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_pool_light_type_mode;
            device.lightColorMode = poolLightSwitchMode.g_pool_light_mode;
          }
        } else if (poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.AQUAQUIP_MULTI_COLOUR) {
          // AquaQuip Multi Colour (Generic) Brand with NO color palette, just next colour button
          const idleColorMode = AQUAQUIP_COLORS.find(c => c.value === 99); // IDLE
          if (idleColorMode && onLightColorClick) {
            device.lightColorName = idleColorMode.name;
            device.lightColourCode = idleColorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_pool_light_type_mode;
            device.lightColorMode = 99;
          }
        }
      } else if (device.aux.aux_type_code === AuxTypeCode.SPA_ELECTRICS_LIGHT) {
        // Spa Electrics Pool Light
        if (poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.SPA_ELECTRICS_MULTI_PLUS) {
          // Spa electrics multi plus Brand with color palette
          const colorMode = SPA_ELECTRICS_COLORS.find(c => c.value === poolLightSwitchMode.g_pool_light_type_mode) || SPA_ELECTRICS_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_pool_light_type_mode;
            device.lightColorMode = poolLightSwitchMode.g_pool_light_mode;
          }
        } else if (poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.SPA_ELECTRICS_MULTI_COLOUR) {
          // Spa Electrics multi Colour (Generic) Brand with NO color palette, just next colour button
          const idleColorMode = SPA_ELECTRICS_COLORS.find(c => c.value === 99); // IDLE
          if (idleColorMode && onLightColorClick) {
            device.lightColorName = idleColorMode.name;
            device.lightColourCode = idleColorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_pool_light_type_mode;
            device.lightColorMode = 99;
          }
        }
      }  else if (device.aux.aux_type_code === AuxTypeCode.PAL_LIGHTING) {
         if (
          poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.PAL_COLOUR_TOUCH ||
          poolLightSwitchMode.g_pool_light_type_mode === LightTypeMode.LIGHT_UNKNOWN
        ) {
          const colorMode = PAL_COLORS.find(c => c.value === poolLightSwitchMode.g_pool_light_mode) || PAL_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = LightTypeMode.PAL_COLOUR_TOUCH;
            device.lightColorMode = poolLightSwitchMode.g_pool_light_mode;
          }
        }else{

        }
      }
    }
    
    if (isSpaLight && poolLightSwitchMode) {
      // Handle spa light
      if (device.aux.aux_type_code === AuxTypeCode.SPA_AQUAQUIP_LIGHT) {
        // AquaQuip Spa Light
        if (poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.AQUAQUIP_INSTA_TOUCH) {
          // AquaQuip Insta Touch Brand with color palette
          const colorMode = AQUAQUIP_COLORS.find(c => c.value === poolLightSwitchMode.g_spa_light_mode) || AQUAQUIP_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_spa_light_type_mode;
            device.lightColorMode = poolLightSwitchMode.g_spa_light_mode;
          }
        } else if (poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.AQUAQUIP_MULTI_COLOUR) {
          // AquaQuip Multi Colour (Generic) Brand with NO color palette, just next colour button
          const idleColorMode = AQUAQUIP_COLORS.find(c => c.value === 99); // IDLE
          if (idleColorMode && onLightColorClick) {
            device.lightColorName = idleColorMode.name;
            device.lightColourCode = idleColorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_spa_light_type_mode;
            device.lightColorMode = 99;
          }
        }
      } else if (device.aux.aux_type_code === AuxTypeCode.SPA_SPA_ELECTRICS_LIGHT) {
        // Spa Electrics Spa Light
        if (poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.SPA_ELECTRICS_MULTI_PLUS) {
          // Spa electrics multi plus Brand with color palette
          const colorMode = SPA_ELECTRICS_COLORS.find(c => c.value === poolLightSwitchMode.g_spa_light_mode) || SPA_ELECTRICS_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_spa_light_type_mode;
            device.lightColorMode = poolLightSwitchMode.g_spa_light_mode;
          }
        } else if (poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.SPA_ELECTRICS_MULTI_COLOUR) {
          // Spa Electrics multi Colour (Generic) Brand with NO color palette, just next colour button
          const idleColorMode = SPA_ELECTRICS_COLORS.find(c => c.value === 99); // IDLE
          if (idleColorMode && onLightColorClick) {
            device.lightColorName = idleColorMode.name;
            device.lightColourCode = idleColorMode.colors;
            device.lightTypeMode = poolLightSwitchMode.g_spa_light_type_mode;
            device.lightColorMode = 99;
          }
        }
      } else if (device.aux.aux_type_code === AuxTypeCode.SPA_PAL_LIGHTING) {
        // Spa Pal Lighting
        if (
          poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.PAL_COLOUR_TOUCH ||
          poolLightSwitchMode.g_spa_light_type_mode === LightTypeMode.LIGHT_UNKNOWN
        ) {
          const colorMode = PAL_COLORS.find(c => c.value === poolLightSwitchMode.g_spa_light_mode) || PAL_COLORS.find(c => c.value === 99); // Default to IDLE if not found
          if (colorMode && onLightColorClick) {
            device.lightColorName = colorMode.name;
            device.lightColourCode = colorMode.colors;
            device.lightTypeMode = LightTypeMode.PAL_COLOUR_TOUCH;
            device.lightColorMode = poolLightSwitchMode.g_spa_light_mode;
          }
        }
      }
    }
  });

  const isLightDevice = (category: number) => {
    return [
      AuxTypeCode.ASTRAL_POOL_LIGHT,
      AuxTypeCode.POOLRITE_LIGHT,
      AuxTypeCode.AQUAQUIP_LIGHT,
      AuxTypeCode.SPA_ELECTRICS_LIGHT,
      AuxTypeCode.SPA_ASTRAL_POOL_LIGHT,
      AuxTypeCode.SPA_AQUAQUIP_LIGHT,
      AuxTypeCode.SPA_POOLRITE_LIGHT,
      AuxTypeCode.SPA_SPA_ELECTRICS_LIGHT,
      AuxTypeCode.SPA_ZODIAC,
      AuxTypeCode.PAL_LIGHTING,
      AuxTypeCode.SPA_PAL_LIGHTING,
    ].includes(category);
  };

  const getDeviceIcon = (category: number) => {
    if (isLightDevice(category)) {
      return '💡';
    }
    
    switch (category) {
      case AuxTypeCode.POOL_HEATER:
      case AuxTypeCode.SPA_HEATER:
        return '🔥';
      case AuxTypeCode.SALT_CHLORINATOR:
        return '🧂';
      default:
        return '⚙️';
    }
  };

  const getDeviceColor = (device: AuxWithSchedules) => {
    if (isLightDevice(device.aux.aux_type_code)) {
      return device.aux.aux_status ? 'bg-yellow-500' : 'bg-gray-400';
    }
    return device.aux.aux_status ? 'bg-green-500' : 'bg-gray-400';
  };

  // Get light configuration for a device
  const getLightConfig = (device: AuxWithSchedules) => {
    if (!poolLightSwitchMode || !isLightDevice(device.aux.aux_type_code)) return null;
    
    const isPoolLight = device.aux.aux_type_code === poolLightSwitchMode.g_pool_light_type;
    const isSpaLight = device.aux.aux_type_code === poolLightSwitchMode.g_spa_light_type;
    
    if (isPoolLight) {
      return {
        type: poolLightSwitchMode.g_pool_light_type,
        typeMode: poolLightSwitchMode.g_pool_light_type_mode,
        colorMode: poolLightSwitchMode.g_pool_light_mode,
        isEnabled: true
      };
    }
    
    if (isSpaLight) {
      return {
        type: poolLightSwitchMode.g_spa_light_type,
        typeMode: poolLightSwitchMode.g_spa_light_type_mode,
        colorMode: poolLightSwitchMode.g_spa_light_mode,
        isEnabled: true
      };
    }
    
    return null;
  };

  // Get light color based on color mode and light type
  const getLightColor = (colorMode: number, lightType?: number) => {
    
    // 根据灯光类型选择颜色数组
    const colorArray = [
      AuxTypeCode.SPA_ELECTRICS_LIGHT,
      AuxTypeCode.SPA_SPA_ELECTRICS_LIGHT
    ].includes(lightType || 0)
      ? SPA_ELECTRICS_COLORS
      : [AuxTypeCode.PAL_LIGHTING, AuxTypeCode.SPA_PAL_LIGHTING].includes(lightType || 0)
        ? PAL_COLORS
        : AQUAQUIP_COLORS;
    
    // 查找对应的颜色对象
    const colorObj = colorArray.find(c => c.value === colorMode);
    
    // 如果找到颜色对象，返回颜色数组，否则返回默认白色
    if (colorObj) {
      return colorObj.colors;
    }
    
    // 如果colorMode超出范围，返回默认颜色
    return ['#FFFFFF'];
  };
  
  // 创建CSS渐变背景
  const createGradientBackground = (colors: string[]) => {
    if (colors.length === 1) {
      return colors[0];
    }
    return `linear-gradient(135deg, ${colors.join(', ')})`;
  };

  // Handle light color button click
  const handleLightColorClick = (device: AuxWithSchedules) => {
    if (!poolLightSwitchMode || !onLightColorClick) return;
    
    // 检查设备类型是否为PoolLightsType或SpaPoolLightsType
    const isPoolLight = device.aux.aux_type_code === poolLightSwitchMode.g_pool_light_type;
    const isSpaLight = device.aux.aux_type_code === poolLightSwitchMode.g_spa_light_type;
    
    if (isPoolLight) {
      // 如果是泳池灯，传递PoolLightsTypeMode和PoolLightsColorMode
      //使用LightConfig 结构
      const lightConfig: LightConfig = {
        Type: poolLightSwitchMode.g_pool_light_type,
        TypeMode: poolLightSwitchMode.g_pool_light_type_mode,
        ColorMode: poolLightSwitchMode.g_pool_light_mode,
      };
      onLightColorClick(device, lightConfig);
    } else if (isSpaLight) {
      // 如果是SPA灯，传递SpaPoolLightsTypeMode和SpaPoolLightsColorMode
      //使用LightConfig 结构
      const lightConfig: LightConfig = {
        Type: poolLightSwitchMode.g_spa_light_type,
        TypeMode: poolLightSwitchMode.g_spa_light_type_mode,
        ColorMode: poolLightSwitchMode.g_spa_light_mode,
      };
      
      onLightColorClick(device, lightConfig);
    } else {
      // 如果不是已知的灯光类型，使用原有的getLightConfig函数
      const lightConfig = getLightConfig(device);
      if (lightConfig) {
        onLightColorClick(device, lightConfig);
      }
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Other Devices</h2>
      
      {devicesList.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500 dark:text-gray-400">No other devices configured</p>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {devicesList.map((device) => (
            <div key={`${device.aux.aux_type_code}-${device.aux.aux_slot_num}`} className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700" style={{ height: 'fit-content' }}>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center">
                  <div className={`w-3 h-3 rounded-full mr-3 ${getDeviceColor(device)}`}></div>
                  <div className="text-xl mr-2">{getDeviceIcon(device.aux.aux_type_code)}</div>
                  <div>
                    <h3 className="font-medium text-gray-900 dark:text-gray-100 text-sm truncate" title={device.aux.aux_tag}>{device.aux.aux_tag}</h3>
                    {scheduleInfo && (() => {
                            const nextAction = getNextActionTextBySlot(
                              scheduleInfo,
                              device.aux.aux_type_code,
                              device.aux.aux_slot_num
                            );
                            return nextAction ? (
                              <span className="inline-flex items-center px-2 py-0.5 text-xs border border-slate-200 dark:border-slate-700 rounded mr-2">
                                <div>{nextAction}</div>
                              </span>
                            ) : null;
                          })()}
                       
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  {/* Light Color Button */}
                  {isLightDevice(device.aux.aux_type_code) && (
                    <button
                      onClick={() => handleLightColorClick(device)}
                      className="w-8 h-8 rounded-full border-2 border-white shadow-md transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                      style={{
                        // Use resolved light config when available so newly added light types (e.g., PAL) render colors
                        background: (() => {
                          const cfg = getLightConfig(device);
                          if (cfg) {
                            const colors = getLightColor(cfg.colorMode ?? 99, device.aux.aux_type_code);
                            return createGradientBackground(colors);
                          }
                          return '#9CA3AF';
                        })()
                      }}
                      title="Light Color Control"
                    />
                  )}
                  
                  {/* Device Toggle Switch */}
                  <Switch
                    checked={device.aux.aux_status}
                    onChange={() =>
                      onDeviceToggle(device.aux.aux_type_code, device.aux.aux_slot_num, !device.aux.aux_status)
                    }
                  />
                </div>
              </div>

              {(device.aux.aux_timer ?? 0) > 0 && (
                <div className="mt-2 flex flex-col gap-1">
                  <span className="inline-flex w-fit items-center rounded-full border border-slate-200 px-2.5 py-1 text-xs font-medium text-slate-600 dark:border-slate-700 dark:text-slate-300">
                    <FiClock className="mr-1.5 h-3.5 w-3.5" />
                    Timer {formatAuxTimerDuration(device.aux.aux_timer ?? 0)}
                  </span>
                  {!!device.aux.aux_status && (device.aux.aux_timer_remain_sec ?? 0) > 0 && (
                    <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400">
                      {formatAuxTimerCountdown(device.aux.aux_timer_remain_sec ?? 0)}
                    </span>
                  )}
                </div>
              )}

              {/* Light Color for light devices
              {isLightDevice(device.aux.aux_type_code) && device.lightColorName && device.aux.aux_status && (
                <div className="mt-3 p-2 bg-gray-100 rounded border border-gray-200">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-600">Color</span>
                    <div className="flex items-center">
                      <div 
                        className="w-4 h-4 rounded-full mr-2"
                        style={{
                          background: device.lightColourCode ? 
                            (device.lightColourCode.includes(',') ? 
                              `linear-gradient(135deg, ${device.lightColourCode})` : 
                              device.lightColourCode) : 
                            '#FFD700'
                        }}
                      ></div>
                      <span className="text-xs text-gray-900">{device.lightColorName}</span>
                    </div>
                  </div>
                </div>
              )} */}

              {/* Schedule Info */}
              {Array.isArray(device.schedules) && device.schedules.length > 0 && (
                <div className="mt-3 space-y-3">
                  <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 flex items-center">
                    <FiClock className="w-4 h-4 mr-2 text-gray-600 dark:text-gray-400" />
                    Schedule
                  </h4>
                  <div className="grid grid-cols-1 gap-2">
                  {device.schedules.map((schedule) => (
                      <div key={schedule.schedule_id} className="h-fit">
                        <SchedulePanel
                          schedule={{
                            id: schedule.schedule_id.toString(),
                            name: schedule.schedule_name,
                            time: `${formatMinutesToTime(schedule.start_time)} - ${formatMinutesToTime(schedule.end_time)}`,
                            days: getWeekdayArray(schedule.week_days),
                            enabled: schedule.schedule_state
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OtherDevicesSection;
